import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../components/mensajes';
import { Loader, Dimmer } from 'semantic-ui-react';
import { formatoMonto, seleccionarCampo, validaMonto } from '../util/varios';
import axios from "axios";
import moment from 'moment';


const CatalogoCambiarTasa = props => {

    let op = require('../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');
    let fechaSistema = JSON.parse(sessionStorage.getItem('fechasistema'));

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [body, setBody] = useState([]);

    const txtTasa = useRef();
    const txtFecha = useRef();


    const procesarRegistro = () => {
        setActivate(true);

        let opera = props.ope;

        let endpoint = `${op.conexion}/api/moneda/actualizar/${opera}`;
        axios.post(endpoint, body, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {
                if (opera === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });

                } else if (opera === 2) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Modificado Correctamente', icono: 'exito' });

                } else if (opera === 3) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Eliminado Correctamente', icono: 'exito' });

                }
                setActivate(false);
            }
        }).catch(function (error) {
            let mensaje = '';
            if (error.response === undefined) {
                mensaje = 'Error de Conexion'
            } else {

                if (error.response.data.message === 'duplicate key value violates unique constraint "nombre_moneda_ukey"') {
                    mensaje = 'Ya existe una moneda Con ese nombre'

                } else {
                    mensaje = error.response.data.message
                }
            }
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);
        })
    };

    const onChangeValidar = () => {

        let sigue = true;
        if (props.ope === 1 || props.ope === 2) {

            if (txtTasa.current.value.trim() === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Campo Descripción no debe ir Vacio', icono: 'informacion' });
                sigue = false;
                txtTasa.current.focus();
            } else if (txtFecha.current.value.trim() === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Simbolo', icono: 'informacion' });
                sigue = false;
                txtFecha.current.focus();
            }


            if (sigue) {

                var moneda = [
                    {
                        idmoneda: props.ope === 1 ? 0 : props.idd,
                        valormoneda: txtTasa.current.value.replace(/\./g, '').replace(',', '.'),
                        fecha: txtFecha.current.value
                    }
                ];

                setBody({
                    moneda
                });

                let msg = '';
                if (props.ope === 1) {
                    msg = 'Esta Seguro de Registrar estos Datos.';
                } else if (props.ope === 2) {
                    msg = 'Esta Seguro de Registrar estos Datos.';
                } else if (props.ope === 3) {
                    msg = 'Esta Seguro de Eliminar estos Datos.';
                }

                setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
            }
        }
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();
    };


    const blanquear = () => {
        setActivate(false);
    }

    const cerrarModal = () => {
        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideCancelar();
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                
                txtFecha.current.value = moment(fechaSistema).format('YYYY-MM-DD');
                txtTasa.current.focus();

            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className="fw-bold text-light"><h3>{props.ope === 1 ? 'Registrar Moneda' : props.ope === 2 ? 'Modificar Moneda' : 'Eliminar Moneda'}</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>Cargando...</Loader>
                </Dimmer>

                <div className="col-md-12 row m-0 border-azul py-2 rounded">


                    <div className="col-pd-230 input-group input-group-sm mb-2">
                        <label className="input-group-text" id="inputGroup-sizing-sm">TASA DE CAMBIO:</label>
                        <input type="text" autoComplete='off' ref={txtTasa} onFocus={seleccionarCampo} className="form-control text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" placeholder='0,00' onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                    </div>

                    <div className="col-pd-220 input-group input-group-sm mb-2">
                        <label className="input-group-text" id="inputGroup-sizing-sm">FECHA:</label>
                        <input type="date" autoComplete='off' ref={txtFecha} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={onChangeValidar}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoCambiarTasa;


// WEBPACK FOOTER //
// ./src/catalogos/catalogoCrearTasa.js